// generic components
import React, { Component, Dispatch } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
// @ts-ignore
import { EventSourcePolyfill } from 'event-source-polyfill';
import { ISSEEvents } from './models/core/sse-events';
import * as NotificationPageAction from './store/actions/notification';
import * as AnnouncementPageAction from './store/actions/announcement';
import * as MessagePageAction from './store/actions/messages';
import * as EnrollmentPageAction from './store/actions/enrollment';
import * as LoginPageAction from './store/actions/login';
import * as AttendancePageAction from './store/actions/qrPolling';
import * as QuestionPageAction from './store/actions/question';
import * as ProfilePageAction from './store/actions/profile';
import { RefreshUploadMultiQuestionRequestParam } from './models/action/question';

import TagManager from 'react-gtm-module'
import setupMoment from './store/middlewares/momentSetup';

// bootstrap
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

// override general css
import './scss/style.scss';
import './scss/sqi-style.scss';

// our stuff
import Translator from './core/i18n';

import { IAppProps } from './models/pages/app';
import { IAppState, IAction } from './models/action/core';
import { UserType } from './models/enums/userType';

// pages
import ExternalLogin from './pages/login/external-login';
import ExternalLoginObs from './pages/login/external-login-obs';
import EdevletLogin from './pages/login/edevlet-login';
import Login from './pages/login/login';
import Main from './pages/home/main';
import ShowAllCourses from './pages/course/showAllCourses';
import CourseMain from './pages/course/main';
import CUserHome from './pages/user/main';
import { ProgramAdminCockpit } from './pages/user/program-admin/main';
import ActivitiesDashboard from './components/lesson/Activities-Dashboard/main';
import StorageManagement from './pages/storage-management/storage-management-page';
import OrganizationChartPage from './pages/admin-management/organization-chart-page';
import MasterCoursePage from './pages/admin-management/master-course-page';
import TermPage from './pages/admin-management/term-page';
import CoursePage from './pages/admin-management/course-page';
import UserPage from './pages/admin-management/user-page';
import FilesAddedActivities from './pages/storage-management/files-added-activities/term-list-page';
import FilesAddedCommunicationTools from './pages/storage-management/files-added-communication-tools/file-list-page';
import PersonelFiles from './pages/storage-management/personel-files/file-list-page';
import OtherFiles from './pages/storage-management/other-files/file-list-page';
import AddedActivitiesFileListPage from './pages/storage-management/files-added-activities/file-list-page';
import CAnnouncementMain from './pages/announcement/main';
import Kvkk from './pages/test-componenet/kvkk';
import CMessagesMain from './pages/messages/main';
import ProfileMain from './pages/profile/main';
import ForumPage from './pages/forum/main';
import ReportsPage from './pages/reports/main';
import CalendarMain from './pages/calendar/main';
import EnrollmentReport from './pages/reports/enrollment-reports';
import QuestionBankPage from './pages/questionBank/main';
import { Common } from './core/common';
import ScrollToTop from './components/scroll-to-top/scroll-to-top';
import { setShowAddActivity } from './store/actions/coursePage';
import { Guid } from 'guid-typescript';
import ReactGA from 'react-ga4';
import HelpDeskMain from './pages/helpdesk/main';
import Roles from './pages/roles/main';
import * as LoginActions from './store/actions/login';

import { ConnectedRouter } from 'connected-react-router';
import ErrorBoundary from './components/core/ErrorBoundary';
import ReportPage from './pages/admin-management/reports/report-page';
import AdminSurveyPage from './pages/admin-management/survey/survey-page';
import AdminAnnouncementPage from './pages/admin-management/announcement/announcement-page';
import AdminMessagePage from './pages/admin-management/message/message-page';
import AdminForumPage from './pages/admin-management/forum/forum-page';
import AdminHelpdeskPage from './pages/admin-management/helpdesk/helpdesk-page';
import IframePage from './components/iframe/iframe-page';
import { SecurityContextType, SecurityPermissionType } from './core/SecurityContext';
import StatsPage from './pages/admin-management/stats';
import MyFilesPage from './pages/files/main';
import MyGradesPage from './pages/mygrades/main';
import Settings from './pages/settingsui/main';
import LessonProgressReport from './pages/reports/lesson-progress-reports';
import LessonAssignmentReports from './pages/reports/lesson-assignment-reports';
import ProgramStudentReports from './pages/reports/program-student-stat-reports';
import GeneralCompletionReports from './pages/reports/general-completion-reports';
import SummaryBranchReports from './pages/reports/summary-branch-reports';
import VirtualClassPaymentReports from './pages/reports/virtual-class-payment-reports';
import GeneralActivityReports from './pages/reports/general-activity-reports';
import ContentReports from './pages/reports/content-reports';
import ExternalLogout from './pages/main-navigation/external-logout';
import errorPage, { ErrorPage } from './pages/error/errorPage';
import TwoFactorVerification from './pages/profile/two-factor-verification';
// import TranslationPage from './pages/admin-management/globalization/translation/main';
import LoginLoading from './components/loading/login-loading';

let _common: Common;
const T = Translator.create();
if (process.env.NODE_ENV === 'production') {
    Log.setProductionMode();
}
const _logger = Log.create('App.tsx');
let doesUserHasPermission = false;
interface IIAppState {
    IsActiveSSE: boolean;
    eventSource: any;
    key: string;
    isMessageModelOpen: boolean,
    messageModelClosed: boolean,
    isTimezoneCheck: boolean,
    isTimezoneShow: boolean,
    isLoading: boolean

}
class App extends React.Component<IAppProps, IIAppState> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        this.state = {
            IsActiveSSE: false,
            eventSource: {},
            key: Guid.create().toString(),
            isMessageModelOpen: false,
            messageModelClosed: false,
            isTimezoneCheck: false,
            isTimezoneShow: false,
            isLoading: true
        };


        this.CreateSSE = this.CreateSSE.bind(this);
        this.CloseSSE = this.CloseSSE.bind(this);
        this.renderRouter = this.renderRouter.bind(this);

        this.triggerMessageModal = this.triggerMessageModal.bind(this);
        this.triggerMessageModalClosed = this.triggerMessageModalClosed.bind(this);

    }

    initializeGtm = () => {
        if (this.props.isLogin) {
            const tagManagerArgs = {
                gtmId: 'GTM-MKVQLH4V',
                dataLayer: {
                    organizationName: this.props.organizationName,
                    programName: this.props.programName,
                }
            }

            TagManager.initialize(tagManagerArgs)
        }
    }
    setDefaultCulture = (prevProps: IAppProps) => {
        if (prevProps.defaultCulture !== this.props.defaultCulture) {
            if (!this.props.culture) {
                if (this.props.defaultCulture) {
                    T.setLanguage(this.props.defaultCulture === 'en-US' ? 'en' : this.props.defaultCulture === 'ar-SA' ? 'ar' : 'tr');
                    this.setState({ key: Guid.create().toString() });
                    setupMoment();
                }
            }
        }
    }

    public componentDidUpdate(prevProps: IAppProps) {

        if (this.props.isLogin && !this.state.IsActiveSSE) {
            this.props.dispatch(NotificationPageAction.GetNotifications(true, 0, 10, 1));
            this.props.dispatch(AnnouncementPageAction.GetUnreadAnnouncementCount(false));
            this.props.dispatch(MessagePageAction.GetUnreadMessageCount(false));
            this.props.dispatch(NotificationPageAction.GetActivityNotifications(true, 1, 10, 1));

            this.CreateSSE();
        }
        if (!this.props.isLogin && this.state.IsActiveSSE) {
            this.CloseSSE();
        }
        if (prevProps.culture !== this.props.culture) {
            if (this.props.culture) {
                T.setLanguage(this.props.culture === 'en-US' ? 'en' : this.props.culture === 'ar-SA' ? 'ar' : 'tr');
                this.setState({ key: Guid.create().toString() });
                setupMoment();
            }
        }

        if (prevProps.isLogin !== this.props.isLogin || prevProps.userId !== this.props.userId || prevProps.organizationId !== this.props.organizationId || prevProps.clusterType !== this.props.clusterType) {
            if (this.props.isLogin) {
                doesUserHasPermission = this.props.userType === UserType.Teacher && (this.props.loginPermission!.filter(x => x.role === UserType.ProgramAdmin).length > 0);
                ReactGA.set({ userId: this.props.clusterType + '_' + this.props.organizationId + '_' + this.props.userId });
            } else {
                ReactGA.set({ userId: null });
            }
        }
        if (prevProps.timeZone !== this.props.timeZone) {
            this.getDiffrentTimeZoneCheck();
        }
        this.setDefaultCulture(prevProps);
        this.initializeGtm();
    }


    public LogOut = () => {
        this.props.dispatch(ProfilePageAction.setProfileAction(null, "setProfileAction", "set"))
        this.props.dispatch(LoginActions.AlmsLogOut(() => {
            this.props.dispatch(LoginActions.logOff());
            _common.ClearAuthLocalStorage();
            this.props.dispatch(LoginPageAction.getPageData(this.isHandleLoading()));
        }));
    }




    isHandleLoading() {
        this.setState({ isLoading: false });
    }
    public componentDidMount() {
        const token = localStorage.getItem('access_token');
        
        const urlString = window.location.href;
        const url = new URL(urlString);
        const queryStringToken = url.searchParams.get('token');

        if (!token && !queryStringToken) {
            this.LogOut();
            return;
        }

        this.props.dispatch(LoginPageAction.getPageData(this.isHandleLoading()));

        if (this.props.isLogin && !this.state.IsActiveSSE) {
            this.props.dispatch(NotificationPageAction.GetNotifications(true, 0, 10, 1));
            this.props.dispatch(AnnouncementPageAction.GetUnreadAnnouncementCount(false));
            this.props.dispatch(MessagePageAction.GetUnreadMessageCount(false));
            this.props.dispatch(NotificationPageAction.GetActivityNotifications(true, 1, 10, 1));

            this.CreateSSE();
        }
        if (!this.props.isLogin && this.state.IsActiveSSE) {
            this.CloseSSE();
        }

        if (this.props.isLogin) {
            doesUserHasPermission = this.props.userType === UserType.Teacher && (this.props.loginPermission!.filter(x => x.role === UserType.ProgramAdmin).length > 0);
            ReactGA.set({ userId: this.props.clusterType + '_' + this.props.organizationId + '_' + this.props.userId });
        } else {
            ReactGA.set({ userId: null });
        }

        if (this.props.culture) {
            T.setLanguage(this.props.culture === 'en-US' ? 'en' : this.props.culture === 'ar-SA' ? 'ar' : 'tr');
            this.setState({ key: Guid.create().toString() });
        } else if (this.props.defaultCulture) {
            T.setLanguage(this.props.defaultCulture === 'en-US' ? 'en' : this.props.defaultCulture === 'ar-SA' ? 'ar' : 'tr');
            this.setState({ key: Guid.create().toString() });
        }

        this.getDiffrentTimeZoneCheck();
        setupMoment();
    }


  getCurrentTimeZone = () => {
    return new Date().getTimezoneOffset();
  };

  getDiffrentTimeZoneCheck = () => {
    if (this.props.timeZone) {
      const getUTCOffsetFromTimeZone = (timeZone: any) => {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone,
          timeZoneName: 'short',
        });
        const parts = formatter.formatToParts(now);
        const utcOffsetPart = parts.find((part) => part.type === 'timeZoneName');
        return utcOffsetPart ? utcOffsetPart.value : null;
      };

      const parseUTCOffset = (utcOffsetString: any) => {
        const match = utcOffsetString.match(/GMT([+-]\d+)/);
        return match ? parseInt(match[1], 10) : null;
      };

      const userUTCOffset = -(this.getCurrentTimeZone() / 60);
      const apiTimeZone = this.props.timeZone;
      const apiUTCOffsetString = getUTCOffsetFromTimeZone(apiTimeZone);

      if (apiUTCOffsetString !== null) {
        const apiUTCOffset = parseUTCOffset(apiUTCOffsetString);
        if (userUTCOffset === apiUTCOffset) {
          this.setState({ isTimezoneCheck: false });
        } else {
          this.setState({ isTimezoneCheck: true });
        }
      } else {
        this.setState({ isTimezoneCheck: false });
      }
    }
  };
    public async triggerMessageModal(status: boolean) {
        this.setState({
            isMessageModelOpen: status,
        });

        if (!status) {
            this.triggerMessageModalClosed(true);
        }
    }

    public triggerMessageModalClosed(status = false) {

        this.setState({
            messageModelClosed: status,
        });

    }

    public addMathJax() {
        var mathJaxScrit = document.createElement('script');
        const MathJaxElement = document.getElementById("MathJax");
        if (!MathJaxElement) {
            mathJaxScrit.setAttribute('src', "/custom-plugin/MathJax.js?config=TeX-AMS-MML_HTMLorMML");
            mathJaxScrit.setAttribute('id', "MathJax");

            document.head.appendChild(mathJaxScrit);
        }
    }


    // For redux connected components, we use a function to
    // prevent errors.
    public renderLogin = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <Login {...props} />;
    };

    public getPlatform() {

        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        let platform = 2;

        if (isAndroid) {
            platform = 1;
        }

        return platform;
    }

    public renderMobileStore = (props: any) => {
        window.location.replace(_common.storeLinks(this.props.culture!, this.getPlatform()));
    };
    public renderMain = (props: any) => {
        this.addMathJax();
        return <Main {...props} triggerMessageModal={this.triggerMessageModal} isMessageModelOpen={this.state.isMessageModelOpen} />;
    };
    public renderShowAllCourses = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <ShowAllCourses {...props} />;
    };
    public renderActivitiesDashboard = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ActivitiesDashboard {...props} />;
    };
    public renderStorageManagement = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <StorageManagement {...props} />;
    };
    public renderRoles = (props: any) => {
        return <Roles {...props} />;
    };
    public renderFilesAddedActivities = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <FilesAddedActivities {...props} />;
    };
    public renderFilesAddedCommunicationTools = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <FilesAddedCommunicationTools {...props} />;
    };
    public renderPersonelFiles = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <PersonelFiles {...props} />;
    };
    public renderOtherFiles = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <OtherFiles {...props} />;
    };
    public renderReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ReportPage {...props} />;
    };
    // public renderCourseProgressReport = (props: any) => {
    //     this.props.dispatch(setShowAddActivity(false));
    //     return <CourseProgressReport {...props} />
    // }
    public renderSurvey = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AdminSurveyPage {...props} />;
    };
    public renderAnnouncement = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AdminAnnouncementPage {...props} />;
    };
    public renderMessage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AdminMessagePage {...props} />;
    };
    public renderForum = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AdminForumPage {...props} />;
    };
    public renderHelpdesk = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AdminHelpdeskPage {...props} />;
    };
    public renderAddedActivitiesFileListPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <AddedActivitiesFileListPage {...props} />;
    };
    public renderOrganizationChartPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <OrganizationChartPage {...props} />;
    };
    public renderMasterCoursePage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <MasterCoursePage {...props} />;
    };
    public renderTermPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <TermPage {...props} />;
    };
    public renderCoursePage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <CoursePage {...props} />;
    };
    public renderUserPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <UserPage {...props} />;
    };
    public renderSettingsPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <Settings {...props} />;
    };
    public renderAnnouncementHome = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <CAnnouncementMain {...props} />;
    };
    public renderForumHome = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ForumPage {...props} />;
    };
    public renderReportsPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ReportsPage {...props} />;
    };
    public renderResetPasswordForm = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <Login {...props} />;
    }
    public renderKvkk = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <Kvkk />;
    }
    public renderActivityDetail = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <Kvkk {...props} />;
    }
    public renderMessagesHome = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <CMessagesMain isMessageModelOpen={this.state.isMessageModelOpen} messageModelClosed={this.state.messageModelClosed} triggerMessageModalClosed={this.triggerMessageModalClosed} />;
    };
    public renderProfile = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ProfileMain />;
    }
    public renderExternalLogin = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ExternalLogin />;
    }
    public renderExternalLogout = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <ExternalLogout />;
    }
    public renderExternalLoginObs = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ExternalLoginObs />;
    }
    public renderEdevletLogin = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <EdevletLogin />;
    }
    public renderCalendar = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <CalendarMain />;
    }
    public renderHelpDesk = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <HelpDeskMain />;
    }

    public renderFiles = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <MyFilesPage />;
    }

    public renderMyGrades = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <MyGradesPage />;
    }
    public renderEnrollmentReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <EnrollmentReport />;
    }
    public renderLessonProgressReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <LessonProgressReport />;
    }
    public renderLessonAssignmentReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <LessonAssignmentReports />;
    }
    public renderProgramStudentStatReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ProgramStudentReports />;
    }
    public renderGeneralCompletionReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <GeneralCompletionReports />;
    }
    public renderSummaryBranchReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <SummaryBranchReports />;
    }
    public renderVirtualClassPaymentReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <VirtualClassPaymentReports />;
    }

    public renderGeneralActivityReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <GeneralActivityReports />;
    }
    public renderContentReport = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <ContentReports />;
    }
    public renderCourseMain = (props: any) => {
        this.props.dispatch(setShowAddActivity(true));
        return <CourseMain />;
    }
    public renderCUserHome = (props: any) => {
        if (this.props.isLogin)
            return <CUserHome IsActiveSSE={this.state.IsActiveSSE} />;
    }
    public renderError = (props: any) => {
        return <ErrorPage />;
    }
    public renderQuestionBank = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <QuestionBankPage />;
    }
    public renderIframePage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));

        return <IframePage {...props} />;
    };
    public renderProgramAdminCockpit = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <ProgramAdminCockpit />;
    }
    public renderStatsPage = (props: any) => {
        this.props.dispatch(setShowAddActivity(false));
        return <StatsPage />;
    }
    public renderVerificationPage = (props: any) => {
        return <TwoFactorVerification />;
    }

    componentDidCatch() {
        window.location.href = window.appSettings.DEFAULT_URL + '/u/error/';
    }

    public renderRouter = () => {
        const boldDescription = `<b>${this.props.userName ?? ''}</b>`
        return (
            <ErrorBoundary userId={this.props.userId} userName={this.props.fullName}>
                <ConnectedRouter history={this.props.history} >
                    <div key={this.state.key}>
                        <ScrollToTop />
                        {/* <Switch> */}
                        <Route
                            exact={true}
                            path={window.appSettings.DEFAULT_URL + '/'}
                            render={this.renderLogin}
                        />
                        <Route
                            exact={true}
                            path={'/mobileStore'}
                            render={this.renderMobileStore}

                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/course'}
                            render={this.renderCourseMain}
                        />

                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/home/index'}
                            render={event => this.renderCUserHome(this.state)}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/error'}
                            render={event => this.renderError(this.state)}
                        />
                        {this.props.userType !== UserType.Student ?
                            <Route
                                path={window.appSettings.DEFAULT_URL + '/u/files/index'}
                                render={event => this.renderFiles(this.state)}
                            />
                            : ''
                        }
                        {this.props.userType == UserType.Student ?
                            <Route
                                path={window.appSettings.DEFAULT_URL + '/u/mygrades/index'}
                                render={event => this.renderMyGrades(this.state)}
                            />
                            : ''
                        }
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/mycourse'}
                            render={this.renderShowAllCourses}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/activities-dashboard'}
                            render={this.renderActivitiesDashboard}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/Home/Cockpit'}
                            render={this.props.userType === UserType.Admin ? event => this.renderCUserHome(this.state) : this.renderProgramAdminCockpit}
                        />
                        {this.props.userType === UserType.Admin ? (
                            <>
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/storage-management'}
                                    render={this.renderStorageManagement}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/roles'}
                                    render={this.renderRoles}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/files-added-activities'}
                                    render={this.renderFilesAddedActivities}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/files-added-communication-tools'}
                                    render={this.renderFilesAddedCommunicationTools}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/personel-files'}
                                    render={this.renderPersonelFiles}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/other-files'}
                                    render={this.renderOtherFiles}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/report'}
                                    render={this.renderReport}
                                />
                                {/* <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/report/course-progress-report'}
                                    render={this.renderCourseProgressReport}
                                /> */}
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/survey'}
                                    render={this.renderSurvey}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/announcement'}
                                    render={this.renderAnnouncement}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/message'}
                                    render={this.renderMessage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/files-added-activity'}
                                    render={this.renderAddedActivitiesFileListPage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/admin-organization-chart'}
                                    render={this.renderOrganizationChartPage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/admin-master-course'}
                                    render={this.renderMasterCoursePage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/admin-term'}
                                    render={this.renderTermPage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/admin-course'}
                                    render={this.renderCoursePage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/admin-user'}
                                    render={this.renderUserPage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/forum'}
                                    render={this.renderForum}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/helpdesk'}
                                    render={this.renderHelpdesk}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/current'}
                                    render={this.renderIframePage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/u/Stats'}
                                    render={this.renderStatsPage}
                                />
                                <Route
                                    path={window.appSettings.DEFAULT_URL + '/external-logout'}
                                    component={this.renderExternalLogout}
                                />
                            </>
                        ) : null}

                        <Route
                            path={
                                window.appSettings.DEFAULT_URL +
                                '/u/announcement/index'
                            }
                            render={this.renderAnnouncementHome}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/external-login'}
                            component={this.renderExternalLogin}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/external-logout'}
                            component={this.renderExternalLogout}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/external-login-obs'}
                            component={this.renderExternalLoginObs}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/edevlet-login'}
                            component={this.renderEdevletLogin}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/reset-password-form'}
                            render={this.renderResetPasswordForm}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/kvkk'}
                            render={this.renderKvkk}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/activity/detail/:id'}
                            render={this.renderActivityDetail}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/message/index'}
                            render={this.renderMessagesHome}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/forum/index'}
                            render={this.renderForumHome}
                        />

                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/helpdesk/index'}
                            render={this.renderHelpDesk}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/index'}
                            render={this.renderReportsPage}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/profile'}
                            render={this.renderProfile}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/calendar'}
                            render={this.renderCalendar}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/enrollment'}
                            render={this.renderEnrollmentReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/lesson-progress'}
                            render={this.renderLessonProgressReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/lesson-assignment'}
                            render={this.renderLessonAssignmentReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/program-student-report'}
                            render={this.renderProgramStudentStatReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/general-completion-report'}
                            render={this.renderGeneralCompletionReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/Question/Index'}
                            render={this.renderQuestionBank}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/summary-branch-report'}
                            render={this.renderSummaryBranchReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/virtual-class-payment-report'}
                            render={this.renderVirtualClassPaymentReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/general-activity-report'}
                            render={this.renderGeneralActivityReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/reports/content-report'}
                            render={this.renderContentReport}
                        />
                        <Route
                            path={window.appSettings.DEFAULT_URL + '/u/settingsui'}
                            render={this.renderSettingsPage}
                        />
                        {
                            (this.props.userType === UserType.ProgramAdmin) || (doesUserHasPermission) ? (
                                <>
                                    <Route
                                        path={window.appSettings.DEFAULT_URL + '/u/admin-master-course'}
                                        render={this.renderMasterCoursePage}
                                    />
                                    <Route
                                        path={window.appSettings.DEFAULT_URL + '/u/admin-course'}
                                        render={this.renderCoursePage}
                                    />
                                    <Route
                                        path={window.appSettings.DEFAULT_URL + '/u/admin-user'}
                                        render={this.renderUserPage}
                                    />

                                    <Route
                                        path={window.appSettings.DEFAULT_URL + '/u/settingsui'}
                                        render={this.renderSettingsPage}
                                    />
                                </>
                            ) : null
                        }

                        {/* <Route path={"*"}
                        exact
                            render={this.renderError}
                        />
                    </Switch> */}
                        <Route

                            path={window.appSettings.DEFAULT_URL + '/u'}
                            render={this.renderMain}
                        />

                        <Route
                            path={window.appSettings.DEFAULT_URL + '/verification'}
                            render={this.renderVerificationPage}
                        />
                    </div>

                </ConnectedRouter>
                {
                    this.props.isSimulate &&
                    <div className={`simulate-popup ${!this.state.isTimezoneCheck ? '': 'timezone_added'}`}>
                        <div className='d-flex align-items-center justify-content-center w-100'>
                            <p className='my-auto' dangerouslySetInnerHTML={{ __html: T.t('r_simulate_user_popup_description').replace('{0}', boldDescription) }} />

                            <span>
                                <button onClick={this.handleClick}>
                                    {T.t('r_simulate_user_exit_simulate')}
                                </button>
                            </span>
                        </div>
                    </div>
                }
            </ErrorBoundary>
        );
    }

    shouldComponentUpdate(nextProps: any, nextState: any, prevProps: any) {
        if (nextProps !== this.props || nextState !== this.state || (nextProps.userName !== this.props.userName && nextProps.userName && nextProps.userName.length > 0)) {
            return true;
        } else {
            return false;
        }
    }

    handleClick = () => {
        this.props.dispatch(ProfilePageAction.setProfileAction(null, "setProfileAction", "set"))
        this.props.dispatch(LoginPageAction.logOff("exitfromsimulate"));
    }

    public render() {
        const { isLoading } = this.state;

        if (isLoading) {
            return (
                <LoginLoading />
            )
        } else {
            return (
                this.renderRouter()
            );
        }
    }

    private CreateSSE() {
        const eventSourceLocal = new EventSourcePolyfill(window.appSettings.EVENTS_URL, {
            headers: {
                'Authorization': 'Bearer ' + _common.GetAuthLocalStorage().access_token
            }
        }) as EventSource;

        this.setState({
            eventSource: eventSourceLocal
        });

        eventSourceLocal.addEventListener('inventory', (e: any) => {
            if (e.data) {
                const userInventory: ISSEEvents = JSON.parse(e.data);
                if (userInventory?.IsNotificationAvailable) {
                    this.props.dispatch(NotificationPageAction.GetNotifications(true, 0, 10, 1, true));
                    this.props.dispatch(NotificationPageAction.GetActivityNotifications(true, 1, 10, 1, true));
                }

                if (userInventory?.IsAnnouncementNotificationAvailable) {
                    this.props.dispatch(AnnouncementPageAction.GetUnreadAnnouncementCount(false));
                }

                if (userInventory?.IsMessageNotificationAvailable) {
                    this.props.dispatch(MessagePageAction.GetUnreadMessageCount(false, true));
                }
                if (userInventory?.IsEnrollmentRefresh) {
                    this.props.dispatch(EnrollmentPageAction.getRefreshMyEnrollments("getRefreshMyEnrollments", "get"));
                }
                if (userInventory?.IsAttendanceRefresh) {
                    this.props.dispatch(AttendancePageAction.GetRefreshAttendances(undefined, "getRefreshGeneralAttendances", "get"));
                }
                if (userInventory?.IsUploadMultiQuestionRefresh) {
                    const parameters: RefreshUploadMultiQuestionRequestParam = {
                        trackingGuid: this.props.multiQuestionFileUploadId,
                        uploadMultiQuestionIds: userInventory.UploadMultiQuestionIds
                    }
                    this.props.dispatch(QuestionPageAction.GetRefreshUploadMultiQuestion(parameters, "getRefreshUploadMultiQuestion", "get"));
                }
            }
        }, false);
        this.setState({ IsActiveSSE: true });
    }

    private CloseSSE() {
        const eventSourceLocal = (this.state.eventSource as EventSource);
        eventSourceLocal.close();
        this.setState({ IsActiveSSE: false });
    }
}
const mapStateToProps = (state: IAppState, ownProps: IAppProps): IAppProps => {
    if (!state) {
        return ownProps;
    }
    const returnProps: IAppProps = Object.assign({}, ownProps, {
        isLogin: state.login.identitiy.isLogin,
        userType: state.login.identitiy.userType,
        culture: state.login.identitiy.culture,
        defaultCulture: state.login.login.defaultCulture,
        organizationId: state.login.identitiy.organizationId,
        clusterType: state.login.identitiy.clusterType,
        userId: state.login.identitiy.userId,
        fullName: state.login.identitiy.fullName,
        userName: state.login.identitiy.userName,
        loginPermission: state.login.identitiy.loginPermission,
        isSimulate: state.login.identitiy.isSimulate,
        programName: state.login.identitiy.programName,
        organizationName: state.login.login.organizationName,
        isAlmsPlusLoginPage: state.login.login.isAlmsPlusLoginPage,
        multiQuestionFileUploadId: state.question.multiQuestionFileUploadId,
        timeZone: state.login.identitiy.timeZone
    });

    return returnProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CApp = connect(
    mapStateToProps,
    dispatchProps
)(App);

export default CApp;
